import { render, staticRenderFns } from "./snackbars.vue?vue&type=template&id=54d6781d&"
import script from "./snackbars.vue?vue&type=script&lang=js&"
export * from "./snackbars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports